import {createSettingsContext as $eik1J$createSettingsContext} from "@macrostrat/ui-components";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $b9d7b3b9bd11faad$exports = {};

$parcel$export($b9d7b3b9bd11faad$exports, "SettingsProvider", () => $b9d7b3b9bd11faad$export$e134aa690da9cc14);
$parcel$export($b9d7b3b9bd11faad$exports, "useSettings", () => $b9d7b3b9bd11faad$export$9115b42802a3e44f);
$parcel$export($b9d7b3b9bd11faad$exports, "updateSettings", () => $b9d7b3b9bd11faad$export$f558026a994b6051);

// This will eventually help us move to "@macrostrat/ui-components" for settings provision
const [$b9d7b3b9bd11faad$export$e134aa690da9cc14, $b9d7b3b9bd11faad$export$9115b42802a3e44f, $b9d7b3b9bd11faad$var$useSettingsUpdater] = (0, $eik1J$createSettingsContext)({});
// Deprecated: this is kind of confusing
const $b9d7b3b9bd11faad$export$f558026a994b6051 = function(func) {
    // Update settings using `immutability-helper` semantics
    const updater = $b9d7b3b9bd11faad$var$useSettingsUpdater();
    return function() {
        return updater(func(...arguments));
    };
};


export {$b9d7b3b9bd11faad$export$e134aa690da9cc14 as SettingsProvider, $b9d7b3b9bd11faad$export$9115b42802a3e44f as useSettings, $b9d7b3b9bd11faad$export$f558026a994b6051 as updateSettings};
//# sourceMappingURL=column-components.72f490e5.js.map
